import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-start" }
const _hoisted_2 = { class: "my-3 pt-1 mr-4 ml-0" }
const _hoisted_3 = { class: "d-flex align-start" }
const _hoisted_4 = { class: "my-3 pt-1 mr-4 ml-0" }
const _hoisted_5 = { class: "pt-10" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, {
          value: _ctx.$t('features.nursery-web-account-management-staff')
        }, null, 8, ["value"]),
        _createVNode(_component_v_spacer),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_checkbox, {
            modelValue: _ctx.isHiddenOnly,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isHiddenOnly) = $event)),
            disabled: _ctx.loading,
            class: "my-0",
            "hide-details": "",
            color: "primary"
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('settings.showHidden')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_checkbox, {
            modelValue: _ctx.check,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.check) = $event)),
            disabled: _ctx.loading,
            class: "my-0",
            "hide-details": "",
            color: "primary"
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('settings.showRetired')), 1)
        ]),
        _createVNode(_component_v_menu, { "offset-y": "" }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              class: "mr-2 my-2",
              color: "primary",
              variant: "outlined",
              disabled: _ctx.loading
            }, props), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-tray-arrow-down", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
              ]),
              _: 1
            }, 16, ["disabled"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { href: _ctx.importStaffSampleCsvUrl }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.sampleCsv')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.importDialog = true)),
          class: "mr-2 my-2",
          color: "primary",
          variant: "outlined",
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.bulkImport')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_v_btn, {
          onClick: _ctx.createStaff,
          color: "primary",
          variant: "flat",
          disabled: _ctx.loading,
          class: "my-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.create')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-0"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('common.name')), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('common.gender')), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('settings.assignmentDate')), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('settings.retireDate')), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('settings.classInCharge')), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('common.edit')), 1)
            ])
          ]),
          _createVNode(_component_draggable, {
            modelValue: _ctx.displayedStaff,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.displayedStaff) = $event)),
            tag: "tbody",
            "item-key": "userNurseryId",
            handle: ".drag-handle",
            animation: "200",
            onEnd: _ctx.onDragEnd
          }, {
            item: _withCtx(({ element: s }) => [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_12, [
                  _createVNode(_component_v_icon, {
                    class: "drag-handle",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" mdi-drag ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(s.lastName + s.firstName), 1)
                ]),
                _createElementVNode("td", _hoisted_13, [
                  (s.gender == 'male')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "light-blue",
                        theme: "dark",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.male')), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        color: "pink-lighten-2",
                        theme: "dark",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.female')), 1)
                        ]),
                        _: 1
                      }))
                ]),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatDisplayDate(s.assignDate)), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatDisplayDate(s.retireDate)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(s.classesInCharge.length ? s.classesInCharge.find((c) => c.className)?.className : ""), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(_component_v_btn, {
                    onClick: ($event: any) => (_ctx.clickStaff(s)),
                    color: "primary",
                    variant: "flat",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "onEnd"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.importDialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.importDialog) = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('settings.bulkImport')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          "align-self": "center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.csvFile')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          "align-self": "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_file_input, {
                              modelValue: _ctx.importFile,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.importFile) = $event)),
                              accept: ".csv",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "auto"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.importDialog = false)),
                          color: "grey",
                          variant: "text"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.importCsv,
                          disabled: !_ctx.importFile,
                          loading: _ctx.loading,
                          color: "primary",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.import')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}